import parse from 'html-react-parser';
import type { SanitizedHtml } from 'service/html/htmlService';

// content must already have gone through HTMLService.sanitizeRichText -
// this only maps markup to React elements, it is not a security boundary
export const SanitizedHtmlRenderer = ({
  content,
  className,
}: {
  content: SanitizedHtml;
  className?: string;
}) => <div className={className}>{parse(content)}</div>;
